module.exports = __webpack_public_path__ + "img/high-nan-img.4ad0a9f2.png";